import '../assets/NcGuestContent-CYYZPMjb.css';
import { n } from "../chunks/_plugin-vue2_normalizer-Bj5bLKV4.mjs";
const s = {
  name: "NcGuestContent",
  mounted() {
    document.getElementById("content").classList.add("nc-guest-content");
  },
  destroyed() {
    document.getElementById("content").classList.remove("nc-guest-content");
  }
};
var c = function() {
  var t = this, e = t._self._c;
  return e("div", { attrs: { id: "guest-content-vue" } }, [t._t("default")], 2);
}, o = [], a = /* @__PURE__ */ n(
  s,
  c,
  o,
  !1,
  null,
  "36ad47ca",
  null,
  null
);
const u = a.exports;
export {
  u as default
};
